import { Certificate } from '@revenuemarket/bank';
import { Colors, DropdownButton, Flex, Text } from '@revenuemarket/cds';

import { RefinedCodefCert } from '~types/codef';

import CertListRegisterSection from './CertListRegisterSection';
import { CertificateRegisterType } from './CertificateSection';

interface Props {
  drivePaths: string[];
  drivePath?: string;
  setDrivePath: (path: string) => void;
  certificates: RefinedCodefCert[];
  registeredCertificates: Certificate[];
  setSelectedCertificate: (certificate: RefinedCodefCert) => void;
  selectedCertificate?: RefinedCodefCert;
  setType: (type: CertificateRegisterType) => void;
  isLoading: boolean;
}
const USBRegisterSection = ({
  drivePaths,
  drivePath,
  setDrivePath,
  certificates,
  registeredCertificates,
  setSelectedCertificate,
  selectedCertificate,
  setType,
  isLoading,
}: Props) => {
  return (
    <Flex direction="column" gap={24}>
      <DropdownButton
        disableScroll
        autoClose
        title={
          <Text
            textStyle="14_500"
            style={{
              color: drivePath === 'submenu' ? Colors.grayOpacity52 : Colors.gray800,
            }}
          >
            {drivePath === 'submenu' ? '이동식디스크를 선택해주세요...' : drivePath}
          </Text>
        }
        menu={{
          items: drivePaths.map((path) => ({
            label: path,
            key: path,
          })),
          selectedKeys: [drivePath ?? ''],
          onClick: (e) => {
            setDrivePath(e.key);
          },
        }}
      />
      {drivePath !== 'submenu' && (
        <CertListRegisterSection
          certificates={certificates}
          registeredCertificates={registeredCertificates}
          setSelectedCertificate={setSelectedCertificate}
          selectedCertificate={selectedCertificate}
          setType={setType}
          isLoading={isLoading}
        />
      )}
    </Flex>
  );
};

export default USBRegisterSection;
